import React, { Component } from "react";
import ReactDOM from 'react-dom';
import Grid from '@material-ui/core/Grid'
import ThreeDRotation from '@material-ui/icons/ThreeDRotation';
import TelegramIcon from '@material-ui/icons/Telegram';
import TwitterIcon from '@material-ui/icons/Twitter';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GitHubIcon from '@material-ui/icons/GitHub';
import GTranslateIcon from '@material-ui/icons/GTranslate';

import './teamcard12.css'

const Featurescards = (props) => {
  return (
    <Grid
      container
      direction="column"
      justify="center"
      xs={12}
      sm={3}
      
      className="px-3"
      
    >
        <div className="bc---teamCard py-4 px-3 my-3 text-center" style={{padding: '15px !important',
          /* background-color: yellow; */minHeight: '300px',backgroundColor: '#dcdcdc',color: '#black'
        }} > 
            <img src={props.image} className="img-fluid mx-auto" style={{width: '150px',height:'150px',border:"5px solid #fdd53b" ,borderRadius:100,objectFit: 'cover'}}/>
            <p className="mt-3 pt-1" style={{color:"black",fontSize:'18px!important'}} ><strong>{props.name}</strong></p>
            <p className="mt-3 pt-1" style={{color:"#7a7070"}} >{props.designation}</p>
            {/* <p className="mt-3 pt-1" style={{minHeight: "107px"}}>{props.discription}</p> */}
            
            <div style={{display:"flex",justifyContent: "center"}}>
            {props.facebook != '@' &&
              <a href={props.facebook} className="Pcat---social" ><ThreeDRotation color="red" /></a>
            } 
              
             
             {props.linkedin != '@' &&
              <a href={props.linkedin} target="_blank" className="Pcat---social mx-1" ><LinkedInIcon style={{color:"black"}} /></a>
            }
            {props.twitter != '@' &&
              <a href={props.twitter} target="_blank" className="Pcat---social mx-1" ><TwitterIcon  style={{color:"black"}}/></a>
            }

            {props.github1 != '@' &&
              <a href={props.github1} target="_blank" className="Pcat---social mx-1"><GitHubIcon style={{color:"#ffffff"}} /></a>
            }
            
            {props.github != '@' &&
              <a href={props.github} target="_blank" className="Pcat---social mx-1" ><GitHubIcon style={{color:"#ffffff"}} /></a>
            }
            
            
            {/* {props.google != '@' &&
            <a href="https://gdg.community.dev/u/mznn6z/" target="_blank">
            <img src={props.google} className="img-fluid mx-auto" style={{width: "32px",
              paddingBottom: "18px",objectFit: 'cover'}}/>
              </a>
              // <a href={props.google} ><GTranslateIcon /></a>
            } */}
              
              
            </div>
            </div>
    </Grid>
  );
}

export default Featurescards;
